<seds-modal>
  <div header>
    <div class="header-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" fill="var(--seds-color-brand-primary-light, #687DB0)" />
        <rect x="11" y="10" width="2" height="6" rx="1" fill="white" />
        <rect x="11" y="7" width="2" height="2" rx="1" fill="white" />
      </svg>
      <h2 class="modal-title">{{ title }}</h2>
    </div>
  </div>

  <div content>
    <div class="export-modal-content">
      <p class="modal-text">
        Estamos gerando sua lista de acessos. Esse processo pode levar alguns segundos ou minutos, dependendo do volume de dados.
      </p>
      <p class="modal-text">
        Assim que estiver pronta, o botão mudará para <strong>"Baixar lista de acessos"</strong>.
      </p>
    </div>
  </div>
  <div class="footer" footer>
    <button class="link-button" (click)="confirm()">Fechar</button>
    <seds-basic-button
      title="Entendi"
      (click)="confirm()"
    ></seds-basic-button>
  </div>
</seds-modal>

